import React from "react";

export const IlParrocchialePrivacyPolicyPage: React.FC = () => {
  return (
    <div className="min-h-screen flex justify-center">
      <div className="bg-white rounded-2xl shadow-md p-8 max-w-3xl w-full">
        <h1 className="text-3xl font-bold mb-6 text-center">
          Privacy & Cookie Policy
        </h1>

        <section className="mb-6">
          <h2 className="text-xl font-semibold mb-2">1. Titolare del trattamento</h2>
          <p>
            I dati raccolti tramite la piattaforma <strong>Il Parrocchiale</strong>
            sono trattati dagli organizzatori del torneo promosso dalla{" "}
            <strong>Parrocchia San Luigi di Reggio Emilia</strong>, esclusivamente
            per finalita connesse alla gestione dell'evento e dei servizi collegati.
          </p>
        </section>

        <section className="mb-6">
          <h2 className="text-xl font-semibold mb-2">2. Dati raccolti</h2>
          <ul className="list-disc list-inside space-y-1">
            <li>Dati identificativi e anagrafici inseriti in fase di registrazione</li>
            <li>Dati di contatto, come email o altri recapiti forniti dall'utente</li>
            <li>Dati relativi all'iscrizione alle squadre e alla partecipazione al torneo</li>
            <li>Dati tecnici indispensabili al funzionamento dell'area riservata</li>
          </ul>
        </section>

        <section className="mb-6">
          <h2 className="text-xl font-semibold mb-2">3. Finalita del trattamento</h2>
          <p>
            I dati vengono utilizzati per organizzare il torneo, gestire gli account,
            comporre squadre e calendari, pubblicare classifiche e risultati e
            comunicare informazioni di servizio legate alla manifestazione.
          </p>
        </section>

        <section className="mb-6">
          <h2 className="text-xl font-semibold mb-2">4. Base giuridica</h2>
          <p>
            Il trattamento si fonda sull'esecuzione delle attivita richieste
            dall'utente in fase di iscrizione e sulla necessita di gestire in modo
            corretto l'organizzazione del torneo.
          </p>
        </section>

        <section className="mb-6">
          <h2 className="text-xl font-semibold mb-2">5. Cookie Policy</h2>
          <p>
            La piattaforma utilizza esclusivamente <strong>cookie tecnici</strong>,
            necessari per autenticazione, sicurezza della sessione e corretto
            funzionamento dell'applicativo. Non vengono utilizzati cookie di
            profilazione o marketing.
          </p>
        </section>

        <section className="mb-6">
          <h2 className="text-xl font-semibold mb-2">6. Conservazione dei dati</h2>
          <p>
            I dati sono conservati per il tempo necessario alla gestione del torneo,
            degli adempimenti organizzativi collegati e di eventuali esigenze
            amministrative o tecniche connesse alla piattaforma.
          </p>
        </section>

        <section className="mb-6">
          <h2 className="text-xl font-semibold mb-2">7. Diritti degli interessati</h2>
          <p>
            Gli utenti possono richiedere accesso, rettifica, aggiornamento o
            cancellazione dei propri dati, nei limiti previsti dalla normativa
            applicabile, rivolgendosi direttamente agli organizzatori del torneo.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-2">8. Modifiche alla policy</h2>
          <p>
            Questa informativa puo essere aggiornata nel tempo per adeguarsi a
            cambiamenti organizzativi, tecnici o normativi. La versione piu recente
            restera sempre disponibile su questa pagina.
          </p>
        </section>
      </div>
    </div>
  );
};
